// UsersView.vue
<template>
    <w-flex wrap>
        <div class="lg12 headline text-left pl7">
            Users Management
        </div>
    </w-flex>
<p class="error text-left pa3" >When the role is changed it will take at least 5 minutes to establish the new priviliges. <br>
    If any problems is encountered ask the user to logout and wait 5 minutes</p>
    <PaginationNav :paginationStore="usersStore" />
    <w-table :mobile-breakpoint=700 :items="table.users" :headers="table.columns" :loading="table.loading">
        <template v-slot:[`item-cell.butt`]="{ item }">
            <w-button @click="openRoleChangeDialog(item)">Change Role</w-button>
        </template>
        <template #no-data> No users found </template>
    </w-table>
    <PaginationNav :paginationStore="usersStore" />

    <w-overlay v-model="isDialogOpen" :persistent="true" :persistent-no-animation="false" :opacity="0.3" class="pa10">
        <w-card pa3 bg-color="white">
            <template #title>Change {{ selectedUser.name }}'s role</template>
            <w-radios :items="radioItems" inline v-model="selectedUser.role"></w-radios>
            <template #actions>
                <div class="spacer"></div>
                <w-button class="pa2 ma1" @click="cancelChange">Cancel</w-button>
                <w-button ma2 class="pa2 ma1" @click="confirmChange">Confirm</w-button>
            </template>
        </w-card>
    </w-overlay>
</template>

<script>

import { reactive, ref, onMounted, watch } from 'vue';
import { usersStore } from "../store/users-store";
import PaginationNav from '@/modules/rovers/components/PaginationNav.vue';

export default {
    components: {
        PaginationNav
    },
    setup() {
        const isDialogOpen = ref(false);
        const selectedUser = ref(null);
        const radioItems = [
            { label: 'Installer', value: "INSTALLER" },
            { label: 'Admin', value: "ADMIN" }
        ]
        const table = reactive({
            columns: [
                { label: 'ID', key: 'id' },
                { label: 'Name', key: 'name' },
                { label: 'Surname', key: 'surname' },
                { label: 'Company', key: 'company' },
                { label: 'Role', key: 'role' },
                {
                    label: ' ', key: 'butt', slot: 'butt',
                    sortable: false
                },
            ],
            users: [],
            loading: true
        });

       
        const populateTable = async () => {
            table.users = await usersStore.loadData(
                usersStore.paginationParams,
                await usersStore.getState().call
            ).finally(table.loading = false);
        };

        const openRoleChangeDialog = (user) => {
            selectedUser.value = { ...user };
            console.log("SELECTED", selectedUser.value);
            isDialogOpen.value = true;
        };

        const cancelChange = () => {
            isDialogOpen.value = false;
            selectedUser.value = null;
        };

        //TODO create
        const confirmChange = async () => {
            //aggiorna lista di uteneti in attesa di essere aggiornati.
            await usersStore.updateUserRole(selectedUser.value);
            isDialogOpen.value = false;
        };

        async function mount() {
            await usersStore.initPagination();
            if (usersStore.getIsInitialized()) {
                table.loading = true;
                populateTable();
            }
        }
        onMounted(() => mount());
        watch(
            () => usersStore.state.data,
            (data) => {
                table.loading = true;
                console.log(data);
                table.users = data;
                table.loading = false;
            }
        );

        return {
            table,
            isDialogOpen,
            selectedUser,
            usersStore,
            radioItems,
            openRoleChangeDialog,
            cancelChange,
            confirmChange
        };
    },
};
</script>

<style scoped>
/* Add some styling here */
</style>
